import { IMAGE_DESKTOP, IMAGE_MOBILE, ICON_FIELD } from '../elements/assets'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { LOTTIE_VISUAL } from '../elements/lottie'

export const FEATURE_BLOCK_WITH_VISUAL = `
...on featureBlockWithVisual_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }
  description

  ${ IMAGE_DESKTOP }
  ${ IMAGE_MOBILE }
  ${ CONVERSATION_BOX }
  ${ LOTTIE_VISUAL }

  cards: featureBlockWithVisualMatrix {
    id
    title
    description
    labelColor
    ${ ICON_FIELD }
    buttons {
      id
      linkTitle {
        url
        title
      }
    }
  }
}
`
